import React, { Component } from "react";
import PropTypes from 'prop-types';
import classnames from 'classnames'

class InputCounter extends Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    maxLength: PropTypes.number,
    isTextarea: PropTypes.bool,
    classNameText: PropTypes.string,
    withoutTop: PropTypes.bool,
    error: PropTypes.string,
  };

  static defaultProps = {
    isTextarea: false,
    classNameText: '',
  };

  state = {
    viewErrorMessage: true
  };


  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
        this.setState(() => ({ viewErrorMessage: !!this.props.error }));
    }
  }


  onInputClick = () => {
    if (this.props.error && this.state.viewErrorMessage) {
        this.setState(() => ({ viewErrorMessage: false }));
    }
  }

  render() {
    const { label, value, onChange, maxLength, isTextarea, classNameText, error } = this.props;
    const length = value.length;

    const inputWrapperClasses = classnames({
      'input-wrap': true,
      'with-error': !!error,
      [classNameText]: isTextarea && classNameText.length > 0,
    });

    return (
      <div className={inputWrapperClasses}>
        {(!this.props.withoutTop || (label?.length > 0 || maxLength > 0)) && <div className="input-top">
          <label htmlFor="address">{label}</label>
          <div className="counter">{length}/{maxLength}</div>
        </div>}
        {isTextarea ? (
          <textarea
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            maxLength={maxLength}
          />
        ) : (
          <input
            type="text"
            value={error && this.state.viewErrorMessage ? this.props.error : value}
            onChange={(e) => onChange(e.target.value)}
            onClick={this.onInputClick}
            maxLength={maxLength}
          />
        )}
      </div>
    );
  }
}

export default InputCounter;
